import request from '@/utils/http';
import { INSR, SRM_FILE_PRE } from '../../constant/constant.js';

// const INSR = '/v50';

// 数据隔离-导出
export const exportWithAuth = data => {
    return request({
        url: `${SRM_FILE_PRE}/lcpReport/exportWithAuth`,
        method: 'post',
        data
    });
};

// 维护-查询列表
export const getBxCostsList = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/list`,
        method: 'post',
        data
    });
};

// 维护-提交
export const submitBxCosts = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/submit`,
        method: 'post',
        data
    });
};

// 维护-删除
export const deleteBxCosts = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/delete`,
        method: 'post',
        data
    });
};

// 维护-新增
export const addBxCosts = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/add`,
        method: 'post',
        data
    });
};

// 维护-编辑
export const updateBxCosts = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/update`,
        method: 'post',
        data
    });
};

// 维护-详情
export const getBxCosts = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/detail/${data}`,
        method: 'get'
    });
};

// 维护-业务场景可选项
export const getBusinessCategory = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/getBusinessCategory`,
        method: 'get',
        params: data
    });
};

// 货运险成本明细-新增
export const addFreight = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/addFreight`,
        method: 'post',
        data
    });
};

// 货运险成本明细-编辑
export const updateFreight = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/updateFreight`,
        method: 'post',
        data
    });
};

// 货运险成本明细-多项保存
export const updateFreightList = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/updateFreightList`,
        method: 'post',
        data
    });
};

// 财产险维护发起审批
export const batchSubmitFlow = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/batchSubmitFlow`,
        method: 'post',
        data
    });
};

// 财产险审批信息
export const insuranceBxCostsApprovalInfo = params => {
    return request({
        url: `${INSR}/insuranceBxCosts/insuranceBxCostsApprovalInfo`,
        method: 'get',
        params
    });
};

// 财产险审批明细列表
export const insuranceBxCostsApprovalPage = data => {
    return request({
        url: `${INSR}/insuranceBxCosts/insuranceBxCostsApprovalPage`,
        method: 'post',
        data
    });
};